import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./container/App";

import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.css";

import { BrowserRouter } from "react-router-dom";
import { ProviderAppContainer } from "./providers/ProviderAppContainer";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <PrimeReactProvider value={{ ripple: true, appendTo: "self" }}>
            <BrowserRouter>
                <div className="min-h-screen w-full surface-ground">
                    <ProviderAppContainer>
                        <App />
                    </ProviderAppContainer>
                </div>
            </BrowserRouter>
        </PrimeReactProvider>
    </React.StrictMode>,
);
